import { useState } from 'react'
import { FadeVisual } from './Fade'
import Button from '../forms/Button'
import classNames from '../../../node_modules/classnames/index'
import styles from './styles/DismissableAlert.css'

const DismissableAlert = ({ text = 'alert' }) => {
  const [isVisible, setIsVisible] = useState(true)
  const closeAlert = () => {
    setIsVisible(false)
  }

  return (
    <FadeVisual show={isVisible} className={classNames({ [styles.closedAlert]: !isVisible })}>
      <div className={styles.main}>
        <div className={styles.text}>
          {text}
        </div>

        <Button
          className={styles.closeButton}
          onClick={closeAlert}
        >
          <i className='fa fa-lg fa-times' />
        </Button>
      </div>
    </FadeVisual>
  )
}

export default DismissableAlert
